import React, { useState } from "react";
import NavbarDateInputMobile from "../main/navbarInputs/navbarDateInput/NavbarDateInputMobile";
import LocationCards from "../shared/locationCards/LocationCards";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LocationSearch from "../shared/locationSearch/LocationSearch";
import MobileLocationSearch from "../main/mobileLocationSearch/MobileLocationSearch";
import { toast } from "react-toastify";
import { base_url } from "../../config";

const MobileSearchBarPage = () => {
  const accessToken = localStorage.getItem("@user");
  const [locationInput, setLocationInput] = useState("");
  const [whatInput, setWhatInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [expandedSection, setExpandedSection] = useState(null); // Track expanded section
  const navigate = useNavigate();
  const [place, setPlace] = useState("");

  const handleWhatChange = (e) => {
    setWhatInput(e.target.value);
  };

  const handleExpand = (section) => {
    setExpandedSection(section);
  };

  const handleCollapse = () => {
    setExpandedSection(null);
  };

  function formatDate(date) {
    if (date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
  }

  const handleSubmit = async (event) => {
    if (place.length <= 0 && whatInput.length <= 0) {
      toast.error("Please select an option!", {
        position: "top-center",
      });
      return;
    }
    event.preventDefault();

  const apiUrl = `${base_url}/tables/table-search`;

    const requestBody = {
      address: place,
      from: formatDate(startDate),
      to: formatDate(endDate),
      search: whatInput,
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        params: {
          access_token: accessToken,
          address: "puducherry",
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("API Response:", response.data);
      navigate("/searchresult", {
        state: {
          data: response.data,
          searchPayload: requestBody,
        },
      });
    } catch (error) {
      navigate("/searchresult", {
        state: { error: error.message, details: error.response?.data || null },
      });
    }
  };

  const handlePlaceInputChange = (event) => {
    setPlace(event.target.value);
  };

  return (
    <>
      <div className="relative w-full p-2.5 overflow-hidden h-full">
        <div className="flex transition-transform duration-500">
          {/* First Tab Content */}
          <div className="w-full flex-shrink-0">
            {/* Where Section */}
            <div
              className={`mob-search-drop-down-wrapper transition-transform duration-300 ${
                expandedSection === "where"
                  ? "fixed inset-0 bg-white z-50 p-6 scale-100 shadow-[0px_-4px_6px_0px_rgba(0,_0,_0,_0.1)]"
                  : "scale-95"
              }`}
              onClick={() => handleExpand("where")}
            >
              <h3 className="mob-search-menu-toggle-title mb-4-imp">Where?</h3>
              <div className="">
                <MobileLocationSearch
                  place={place}
                  handlePlaceInputChange={handlePlaceInputChange}
                />
              </div>
              {expandedSection === "where" && (
                <button
                  className="absolute  top-4 right-4 bg-gray-200 p-2 rounded-full"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the expand
                    handleCollapse();
                  }}
                >
                  Close
                </button>
              )}
            </div>

            {/* When Section */}
            <div
              className={`mob-search-drop-down-wrapper transition-transform duration-300 ${
                expandedSection === "when"
                  ? "fixed inset-0 bg-white z-50 p-6 scale-100 shadow-[0px_-4px_6px_0px_rgba(0,_0,_0,_0.1)]"
                  : "scale-95"
              }`}
              onClick={() => handleExpand("when")}
            >
              <h3 className="mob-search-menu-toggle-title">When?</h3>
              <NavbarDateInputMobile
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                startDate={startDate}
                endDate={endDate}
                expandedSection={expandedSection}
              />
              {expandedSection === "when" && (
                <button
                  className="absolute top-4 right-4 bg-gray-200 p-2 rounded-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCollapse();
                  }}
                >
                  Close
                </button>
              )}
            </div>

            {/* What Section */}
            <div
              className={`mob-search-drop-down-wrapper transition-transform duration-300 ${
                expandedSection === "what"
                  ? "fixed inset-0 bg-white z-50 p-6 scale-100 shadow-[0px_-4px_6px_0px_rgba(0,_0,_0,_0.1)]"
                  : "scale-95"
              }`}
              onClick={() => handleExpand("what")}
            >
              <h3 className="mob-search-menu-toggle-title mb-4-imp">What?</h3>
              <div className="">
                <input
                  className="mobile-search-text-fiels w-input mob-border-btm-0-imp"
                  maxLength={256}
                  value={whatInput}
                  onChange={handleWhatChange}
                  placeholder="Search"
                  type="text"
                />
              </div>
              {expandedSection === "what" && (
                <button
                  className="absolute top-4 right-4 bg-gray-200 p-2 rounded-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCollapse();
                  }}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <section className="mob-search-footer z-[70] absolute bottom-0">
        <div className="clear-all">
          <a
            href="#"
            className="clear-all-mob-search"
            onClick={() => {
              // setLocationInput("");
              // setWhatInput("");
              // setSuggestions([]);
              // setEndDate("");
              // setStartDate("");
              // setPlace("");
              window.location.reload();
            }}
          >
            Clear all
          </a>
        </div>
        <div onClick={handleSubmit} className="mob-search-btn w-button">
          Search
        </div>
      </section>
    </>
  );
};

export default MobileSearchBarPage;
